import { createAsyncActionConstants } from 'utilities/util';

export const TYPES = {
    FETCH_ETS: createAsyncActionConstants('FETCH_ETS'),
    RESET_ETS: createAsyncActionConstants('RESET_ETS'),
    FETCH_ETS_DETAILS: createAsyncActionConstants('FETCH_ETS_DETAILS'),
    RESET_ETS_DETAILS: 'RESET_ETS_DETAILS',
    BULK_UPLOAD_ETS: createAsyncActionConstants('BULK_UPLOAD_ETS'),
    BULK_UPLOAD_EXPORT: createAsyncActionConstants('BULK_UPLOAD_EXPORT'),
    BULK_DOWNLOAD_ETS: createAsyncActionConstants('BULK_DOWNLOAD_ETS'),
    BULK_DOWNLOAD_ETS_FILE: createAsyncActionConstants('BULK_DOWNLOAD_ETS_FILE'),
    BULK_DOWNLOAD_ETS_BLOB: createAsyncActionConstants('BULK_DOWNLOAD_ETS_BLOB'),
    FETCH_BULK_UPLOAD: createAsyncActionConstants('FETCH_BULK_UPLOAD'),
    FETCH_DOWNLOAD_LOGS: createAsyncActionConstants('FETCH_DOWNLOAD_LOGS'),
    RESET_DOWNLOAD: 'RESET_DOWNLOAD',
    SALES_ORDER_IMPORT: createAsyncActionConstants('SALES_ORDER_IMPORT'),
    FETCH_NFTP_BILLABLE: createAsyncActionConstants('FETCH_NFTP_BILLABLE_IMPORT')
}